import { useLanguage } from '@/contexts/LanguageContext';
import { Globe } from 'lucide-react';

export const CyberLayout = ({ children, showLanguageSwitch = true }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <div className="min-h-screen bg-cyber-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="particles-bg">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-cyber-black/50 to-cyber-black" />
        {/* Grid Pattern */}
        <div 
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(#00FF94 1px, transparent 1px), linear-gradient(90deg, #00FF94 1px, transparent 1px)`,
            backgroundSize: '50px 50px'
          }}
        />
      </div>

      {/* Language Switcher - with safe area support for iOS PWA */}
      {showLanguageSwitch && (
        <button
          onClick={toggleLanguage}
          data-testid="language-switch"
          className="fixed right-4 z-50 flex items-center gap-2 px-4 py-2 cyber-btn-outline rounded-md transition-all hover:scale-105"
          style={{
            top: 'max(1.5rem, calc(env(safe-area-inset-top, 0px) + 0.75rem))'
          }}
        >
          <Globe className="w-4 h-4" />
          <span className="font-mono text-sm">{language.toUpperCase()}</span>
        </button>
      )}

      {/* Main Content - with safe area padding for iOS PWA */}
      <main 
        className="relative z-10"
        style={{
          paddingTop: 'env(safe-area-inset-top, 0px)'
        }}
      >
        {children}
      </main>

      {/* Scanlines Overlay */}
      <div className="fixed inset-0 pointer-events-none z-20 scanlines opacity-30" />
    </div>
  );
};

export default CyberLayout;
